import type { SonoraPerson } from 'owa-editor-sonora-types';
import { SonoraVivaRelatedTopicsLabel } from '../SonoraItemResults.locstring.json';
import loc from 'owa-localize';

export const getPrimaryTextForSonoraResultsPeopleItems = (sonoraItem: SonoraPerson): string => {
    return sonoraItem.displayName;
};

export const getSecondaryTextForSonoraResultsPeopleItems = (sonoraItem: SonoraPerson): string => {
    return loc(SonoraVivaRelatedTopicsLabel, sonoraItem.relatedTopicName);
};

export const getTooltipStringForSonoraResultsPeopleItems = (sonoraItem: SonoraPerson): string => {
    const tooltipString: string = [sonoraItem.displayName, sonoraItem.emailAddress]
        .filter(str => str)
        .join('\n');

    return tooltipString;
};

export const insertPeopleSuggestionsIntoComposeEditor = (
    sonoraItem: SonoraPerson,
    insertNodeCallback: (nodeToInsert: HTMLElement) => void
): void => {
    const spanNode = document.createElement('span');
    spanNode.innerText = sonoraItem.emailAddress;
    insertNodeCallback(spanNode);
};
